/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation031.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation031Item {
  text: string;
  number: string;
  subtitle?: string;
}

interface IAnimation031Props {
  items: IAnimation031Item[];
  className?: string;
  exampleTitle?: string;
  exampleImg?: string;
  onCompleted: () => void;
}

const Animation031: FunctionComponent<IAnimation031Props> = ({
  items,
  exampleTitle,
  exampleImg,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [show, setShow] = useState(true);

  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation031 onCompleted');
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className={`animation031 component ${className}`}>
      <img
        className="click-point"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      <div className="animation031-content">
        {items.map((itm: IAnimation031Item, idx: number) => (
          <div
            key={idx}
            className={`animation031-item animation r${idx + 1} ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div className="animation031-indicate-number">
              <div className="animation031-indicate-number-radius">
                {itm.number}
              </div>
            </div>
            <div className="animation031-subcontent">
              <div
                className="animation031-text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
              {itm.subtitle ? (
                <div className="sub-task-text">
                  <Button
                    style={{ fontSize: '1.4rem' }}
                    type="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalOpen(true);
                      setShow(false);
                    }}
                  >
                    {itm.subtitle}
                    <img
                      className="click-point1"
                      hidden={!show}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      {exampleTitle && (
        <Modal
          width="80%"
          className="animation031-modal"
          title={
            <div className="animation031-modal-header">{exampleTitle}</div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <img
            src={require(`../../../../../assets/${exampleImg}`).default}
            alt=""
          />
        </Modal>
      )}
    </div>
  );
};

export default Animation031;
